module.exports = __webpack_public_path__ + "img/QianChuan.6078b1d6.png";